import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import type { Control } from 'react-hook-form'
import { SelectField } from '../../shared/SelectField'
import type { SelectFieldOption } from '../../shared/SelectField'
import type { LoyaltyConfig } from './useLoyaltyConfig'

const STAMP_TARGET_OPTIONS: SelectFieldOption[] = [6, 8, 10, 12, 15, 18, 20, 24].map((n) => ({
  label: String(n),
  value: String(n),
}))

interface CardSetupSectionProps {
  control: Control<LoyaltyConfig>
  stepNumber: number
}

export function CardSetupSection({ control, stepNumber }: CardSetupSectionProps) {
  const { t } = useTranslation()

  return (
    <View className="gap-5 rounded-xl border border-border bg-canvas-card p-6">
      <View>
        <View className="flex-row items-baseline gap-2">
          <Text className="text-lg font-semibold text-primary">{stepNumber}.</Text>
          <Text className="text-lg font-semibold text-primary">{t('loyalty.cardSetup.sectionTitle')}</Text>
        </View>
        <Text className="mt-1 text-sm text-secondary">{t('loyalty.cardSetup.subtitle')}</Text>
      </View>

      <Controller
        control={control}
        name="stampTarget"
        render={({ field, fieldState }) => (
          <View className="gap-2">
            <SelectField
              label={t('loyalty.cardSetup.stampsPerCard')}
              value={String(field.value)}
              options={STAMP_TARGET_OPTIONS}
              error={fieldState.error?.message}
              accessibilityLabel={t('loyalty.cardSetup.stampsPerCard')}
              onValueChange={(value) => field.onChange(parseInt(value, 10))}
            />
            {field.value > 0 && (
              <Text className="text-sm text-secondary">
                {t('loyalty.cardSetup.description', { count: field.value })}
              </Text>
            )}
          </View>
        )}
      />
    </View>
  )
}